<template>
  <q-item-wrapper
    :label="metadataDefault.title"
    :icon="!withoutIcon ? defaultIcon : undefined"
    clickable
    @click="addMetadata"
  />
</template>

<script>
import { generateDefaultMdValue, DEFAULT_ICON } from '../metadataMixin'

export default {
  props: {
    metadataDefault: {
      type: Object,
      required: true
    },
    withoutIcon: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  computed: {
    defaultIcon () {
      return this.metadataDefault.icon || DEFAULT_ICON
    }
  },
  methods: {
    addMetadata () {
      this.$emit('click', generateDefaultMdValue(this.metadataDefault))
    }
  }
}
</script>
